import { ArrowDown } from "lucide-react";
import { SectionLabel } from "@/components/yanre/SectionLabel";
import { Reveal, RevealLines } from "@/components/yanre/Reveal";
import { useLocale } from "@/i18n/LocaleContext";

const TRADITIONAL = ["Manufacturer", "Distributor / Importer", "Dealer / Retailer", "Customer"];
const SUPPORT = ["Personalized Consulting","Technical Guidance","Equipment Selection","Project Support","Optional Logistics Coordination","After-Sales Support","Factory-Backed Warranty"];

const Chain = ({ steps, highlight }) => (
  <div className="space-y-0">
    {steps.map((s, i) => (
      <div key={s}>
        <div
          className={`border px-6 py-4 font-mono text-xs uppercase tracking-[0.15em] ${
            highlight
              ? "border-signal bg-signal/10 text-white"
              : i === steps.length - 1
                ? "border-carbon-600 bg-carbon-800 text-titanium"
                : "border-carbon-700 bg-carbon-900 text-titanium/60"
          }`}
        >
          {s}
        </div>
        {i < steps.length - 1 && (
          <div className="flex justify-center py-1.5">
            <ArrowDown className={`h-4 w-4 ${highlight ? "text-signal" : "text-carbon-600"}`} />
          </div>
        )}
      </div>
    ))}
  </div>
);

export const FactoryDirect = ({ index }) => {
  const { t } = useLocale();
  const direct = ["YANRE FITNESS", t("fd.customer", "Customer")];
  return (
    <section className="section-darker relative overflow-hidden border-t border-carbon-700" data-testid="factory-direct-section">
      <div className="grid-lines absolute inset-0 opacity-40" />
      <div className="container-edge relative py-16 lg:py-24">
        <Reveal>
          <SectionLabel index={index}>Factory Direct</SectionLabel>
        </Reveal>
        <h2 className="mt-8 max-w-4xl font-display text-4xl font-extrabold uppercase leading-[0.92] tracking-tight text-white sm:text-5xl lg:text-6xl">
          <RevealLines
            lines={[
              t("fd.h1a", "Remove the middlemen."),
              <span key="n">
                {t("fd.h1b", "Not the support.")}
              </span>,
            ]}
          />
        </h2>
        <div className="mt-12 grid gap-10 lg:grid-cols-2">
          <Reveal>
            <div>
              <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.25em] text-titanium/40">{t("fd.tradLabel", "Traditional model")}</p>
              <Chain steps={TRADITIONAL.map((s, i) => t(`fd.t${i + 1}`, s))} />
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div>
              <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.25em] text-signal">{t("fd.directLabel", "YANRE Factory Direct")}</p>
              <Chain steps={direct} highlight />
              <div className="mt-6 border border-signal/40 bg-signal/5 p-6" data-testid="factory-trust-statement">
                <p className="font-display text-xl font-extrabold uppercase leading-tight text-white sm:text-2xl">
                  {t("fd.trust", "Your equipment contract and payments are directly with YANRE FITNESS.")}
                </p>
              </div>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.18}>
          <div className="mt-12 border-t border-carbon-700 pt-10">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-titanium/40">
              {t("fd.supportLabel", "Factory-direct doesn't mean doing it alone")}
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {SUPPORT.map((s, i) => (
                <span key={s} className="border border-carbon-600 px-4 py-2 font-mono text-[11px] uppercase tracking-wider text-titanium/70">
                  {t(`fd.s${i + 1}`, s)}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
